// API endpoints
export const API_ENDPOINTS = {
  REGISTER: '/add/User/Record/v1',
  LOGIN: '/login/v1',
  GET_USER: '/get/user',
  VALIDATE_OTP: '/validate/OTPCode/v1',
  EDIT_PROFILE: '/edit/user/profile/v1',
  CHANGE_PASSWORD: '/change_password',
  CONFIRM_ACCOUNT: '/confirm/account-present',
  RESET_PASSWORD: '/reset/user-password',
  EXISTING_MEMBER: '/reset/user-password'
};
